import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderProfileState {
    selectedView: string;
}

const initialState: ProviderProfileState = {
    selectedView: 'info',
};

const providerProfileSlice = createSlice({
    name: 'providerProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = providerProfileSlice.actions;
export default providerProfileSlice.reducer;